import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { getProducts } from "../../api/products";
import { getImageUrl } from "../../api/utils";
import { OK } from "../../utils";
import ProductCard from "../ProductCard";

const FALLBACK_IMAGE = "/assets/images/product-placeholder.svg";

/**
 * RelatedProducts
 * Props:
 * - collectionSlug: string — current product ki collection ka slug
 * - currentProductId: number — current product ko exclude karne ke liye
 */

// ── Product Card ──────────────────────────────────────────────

// ── Skeleton ──────────────────────────────────────────────────
const SkeletonCard = () => (
  <div className="card-product">
    <div className="card-product-wrapper">
      <div
        style={{
          paddingTop: "120%",
          background: "#f4f3ef",
          animation: "pulse 1.4s ease-in-out infinite",
        }}
      />
    </div>
    <div className="card-product-info" style={{ padding: "12px 0" }}>
      <div
        style={{
          background: "#f4f3ef",
          height: 14,
          width: "70%",
          marginBottom: 8,
          animation: "pulse 1.4s ease-in-out infinite",
        }}
      />
      <div
        style={{
          background: "#f4f3ef",
          height: 14,
          width: "40%",
          animation: "pulse 1.4s ease-in-out infinite",
        }}
      />
    </div>
  </div>
);

// ── Main Component ────────────────────────────────────────────
const RelatedProducts = ({
  collectionSlugs = [],
  currentProductId,
  productType,
}) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log(productType, "product type in related");
  useEffect(() => {
    // Agar collection nahi hai toh fetch mat karo
    if (!collectionSlugs || collectionSlugs.length === 0) {
      setLoading(false);
      return;
    }

    const load = async () => {
      setLoading(true);
      try {
        const res = await getProducts(1, {
          collection_id: collectionSlugs.join(","),
          product_type: productType || "TShirt", // Sirf mood type ke products fetch karo
          per_page: 10, // Extra fetch karo taaki exclude ke baad 6-7 bachen
        });
        if (res?.status === OK) {
          // Current product ko exclude karo
          const filtered = (res?.products || [])
            .filter((p) => p.id !== currentProductId)
            .slice(0, 7); // Max 7 products
          setProducts(filtered);
        }
      } catch (err) {
        console.error("RelatedProducts error:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [collectionSlugs, currentProductId]);

  // Agar koi related products nahi hain toh section hide karo
  if (!loading && products.length === 0) return null;

  return (
    <section className="flat-spacing-1 pt_0">
      <div className="container">
        <div className="flat-title">
          <span className="title">More Moods to Explore!</span>
        </div>

        <div className="hover-sw-nav hover-sw-2">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={4}
            navigation={{
              nextEl: ".nav-prev-related",
              prevEl: ".nav-next-related",
            }}
            pagination={{
              clickable: true,
              el: ".sw-pagination-related",
            }}
            breakpoints={{
              320: { slidesPerView: 2, spaceBetween: 15 },
              768: { slidesPerView: 3, spaceBetween: 15 },
              1024: { slidesPerView: 4, spaceBetween: 30 },
            }}
            className="tf-sw-product-sell wrap-sw-over"
          >
            {loading
              ? [...Array(4)].map((_, i) => (
                  <SwiperSlide key={i}>
                    <SkeletonCard />
                  </SwiperSlide>
                ))
              : products.map((product) => (
                  <SwiperSlide key={product.id} lazy="true">
                    <ProductCard product={product} setResponsiveGrid={false} />
                  </SwiperSlide>
                ))}
          </Swiper>

          <div className="nav-sw nav-next-slider nav-next-related box-icon w_46 round">
            <span className="icon icon-arrow-left" />
          </div>
          <div className="nav-sw nav-prev-slider nav-prev-related box-icon w_46 round">
            <span className="icon icon-arrow-right" />
          </div>
          <div className="sw-dots style-2 sw-pagination-related justify-content-center" />
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;
